var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStreakIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 26,
    viewBox: "0 0 68 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 26,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1038,
    transform: "translate(-895 -786)",
    fill: "#F9FAFC"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -591,
    y: -84,
    width: 1457,
    height: 318,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3916_412046)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -361,
    y: -12,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 13C0.5 9.68479 1.81696 6.50537 4.16116 4.16117C6.50537 1.81696 9.68479 0.5 13 0.5C16.3152 0.5 19.4946 1.81696 21.8388 4.16117C24.183 6.50537 25.5 9.68479 25.5 13C25.5 16.3152 24.183 19.4946 21.8388 21.8388C19.4946 24.183 16.3152 25.5 13 25.5C9.68479 25.5 6.50537 24.183 4.16116 21.8388C1.81696 19.4946 0.5 16.3152 0.5 13ZM50.5 13C50.5 9.68479 51.817 6.50537 54.1612 4.16117C56.5054 1.81696 59.6848 0.5 63 0.5C66.3152 0.5 69.4946 1.81696 71.8388 4.16117C74.183 6.50537 75.5 9.68479 75.5 13C75.5 16.3152 74.183 19.4946 71.8388 21.8388C69.4946 24.183 66.3152 25.5 63 25.5C59.6848 25.5 56.5054 24.183 54.1612 21.8388C51.817 19.4946 50.5 16.3152 50.5 13ZM100.5 13C100.5 9.68479 101.817 6.50537 104.161 4.16117C106.505 1.81696 109.685 0.5 113 0.5C116.315 0.5 119.495 1.81696 121.839 4.16117C124.183 6.50537 125.5 9.68479 125.5 13C125.5 16.3152 124.183 19.4946 121.839 21.8388C119.495 24.183 116.315 25.5 113 25.5C109.685 25.5 106.505 24.183 104.161 21.8388C101.817 19.4946 100.5 16.3152 100.5 13Z",
    fill: "#2C74D6"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -360,
    y: -11,
    width: 427,
    height: 220,
    rx: 7,
    stroke: "#EAECF0",
    strokeWidth: 2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1038,
    fill: "white",
    transform: "translate(-895 -786)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -591,
    y: -84,
    width: 1457,
    height: 318,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3916_412046"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -361,
    y: -12,
    width: 429,
    height: 222,
    rx: 8,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreakIcon);
export default "data:image/svg+xml,%3csvg width='68' height='26' viewBox='0 0 68 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3crect width='68' height='26' fill='%23F5F5F5'/%3e %3cg clip-path='url(%23clip0_3916_412046)'%3e %3crect width='1440' height='1038' transform='translate(-895 -786)' fill='%23F9FAFC'/%3e %3cg clip-path='url(%23clip1_3916_412046)'%3e %3crect x='-591' y='-84' width='1457' height='318' rx='8' fill='white'/%3e %3cg clip-path='url(%23clip2_3916_412046)'%3e %3crect x='-361' y='-12' width='429' height='222' rx='8' fill='white'/%3e %3cg opacity='0.15'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M0.5 13C0.5 9.68479 1.81696 6.50537 4.16116 4.16117C6.50537 1.81696 9.68479 0.5 13 0.5C16.3152 0.5 19.4946 1.81696 21.8388 4.16117C24.183 6.50537 25.5 9.68479 25.5 13C25.5 16.3152 24.183 19.4946 21.8388 21.8388C19.4946 24.183 16.3152 25.5 13 25.5C9.68479 25.5 6.50537 24.183 4.16116 21.8388C1.81696 19.4946 0.5 16.3152 0.5 13ZM50.5 13C50.5 9.68479 51.817 6.50537 54.1612 4.16117C56.5054 1.81696 59.6848 0.5 63 0.5C66.3152 0.5 69.4946 1.81696 71.8388 4.16117C74.183 6.50537 75.5 9.68479 75.5 13C75.5 16.3152 74.183 19.4946 71.8388 21.8388C69.4946 24.183 66.3152 25.5 63 25.5C59.6848 25.5 56.5054 24.183 54.1612 21.8388C51.817 19.4946 50.5 16.3152 50.5 13ZM100.5 13C100.5 9.68479 101.817 6.50537 104.161 4.16117C106.505 1.81696 109.685 0.5 113 0.5C116.315 0.5 119.495 1.81696 121.839 4.16117C124.183 6.50537 125.5 9.68479 125.5 13C125.5 16.3152 124.183 19.4946 121.839 21.8388C119.495 24.183 116.315 25.5 113 25.5C109.685 25.5 106.505 24.183 104.161 21.8388C101.817 19.4946 100.5 16.3152 100.5 13Z' fill='%232C74D6'/%3e %3c/g%3e %3c/g%3e %3crect x='-360' y='-11' width='427' height='220' rx='7' stroke='%23EAECF0' stroke-width='2'/%3e %3c/g%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0_3916_412046'%3e %3crect width='1440' height='1038' fill='white' transform='translate(-895 -786)'/%3e %3c/clipPath%3e %3cclipPath id='clip1_3916_412046'%3e %3crect x='-591' y='-84' width='1457' height='318' rx='8' fill='white'/%3e %3c/clipPath%3e %3cclipPath id='clip2_3916_412046'%3e %3crect x='-361' y='-12' width='429' height='222' rx='8' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };